import { Box, styled } from '@mui/material';

export const Content = styled(Box)`
  overflow-y: auto;
  height: calc(100vh - 36px - 20px - 20px);
`;
